import { AnalyticService } from "../connection/analytic-service";
import { AnalyticServiceV2 } from "connection/analytics-service";
import { PopularWordsService } from "connection/popular-words-service";
import { checkErrorMessage, getErrorMessage } from "./errors";
import { GeoplaceService } from "connection/geoplace-service"
import Menu from "assets/menu/menu";
import axios from "axios";

const SET_CLEAR_DATA = "SET-CLEAR-DATA";

const SET_ANALYTIC_IS_FETCHING = "SET-ANALYTIC-IS-FETCHING";

const SET_ANALYTIC_STARTED = "SET-ANALYTIC-STARTED";
const SET_FIRST_DATA = "SET-FIRST-DATA";
const SET_SECOND_DATA = "SET-SECOND-DATA";
const SET_THIRD_DATA = "SET-THIRD-DATA";
const SET_METRIC_DATA = "SET_METRIC_DATA";
const SET_LOCATIONS_NAME = "SET-LOCATIONS-NAME";
const SET_FIRST_MAX = "SET-FIRST-MAX";
const SET_SECOND_MAX = "SET-SECOND-MAX";
const SET_FIRST_LIMIT = "SET-FIRST-LIMIT";

const getDateTimeFormat = (date) => {
    return date//moment(date).format('YYYY-MM-DDTHH:mm:ss')+'Z'
}

const geoplace = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL+"geoplace/api/v1/"
})

const extendedAnalyticData = {
    menuItems: Menu.AnlyticPages,
    isFetching: false,
    fisrt: [],
    second: [],
    third: [],
    metric: [],
    started: false,
    locationsName: null,
    firstMax: null,
    secondMax: null,
    firstLimit: 100
}

let ExtendedAnalytic = (state = extendedAnalyticData, action) =>{
    switch(action.type){
        case SET_CLEAR_DATA:
            return {...state, first: [], second: []}
        case SET_ANALYTIC_IS_FETCHING:
            return {...state, isFetching: action.isFetching}
        case SET_FIRST_DATA:
            return {...state, first: action.fisrt}
        case SET_SECOND_DATA:
            return {...state, second: action.second}
        case SET_THIRD_DATA:
            return {...state, third: action.third}
        case SET_METRIC_DATA:
            return {...state, metric: action.metric}
        case SET_ANALYTIC_STARTED:
            return {...state, started: action.started}
        case SET_LOCATIONS_NAME:
            return {...state, locationsName: action.locationsName }
        case SET_FIRST_MAX:
            return {...state, firstMax: action.max}
        case SET_SECOND_MAX:
            return {...state, secondMax: action.max}
        case SET_FIRST_LIMIT:
            return {...state, limit: action.limit}
        default:
            return {...state}
    }
}

export default ExtendedAnalytic;

/*Set analytic data state */

export const setFirstLimit = (limit) => {
    return {
        type: SET_FIRST_LIMIT,
        firstLimit: firstLimit
    }
}

export const setFirstMax = (max) => {
    return {
        type: SET_FIRST_MAX,
        max: max
    }
}

export const setSecondMax = (max) => {
    return {
        type: SET_SECOND_MAX,
        max: max
    }
}

export const setStarted = (started) => {
    return {
        type: SET_ANALYTIC_STARTED,
        started: started
    }
}

const setFirstData = (data) => {
    return {
        type: SET_FIRST_DATA,
        fisrt: data
    }
}

const setSecondData = (data) => {
    return {
        type: SET_SECOND_DATA,
        second: data
    }
}

const setThirdData = (data) => {
    return {
        type: SET_THIRD_DATA,
        third: data
    }
}

const setMetricData = (data) => {
    return {
        type: SET_METRIC_DATA,
        metric: data
    }
}

export const setAnalyticIsFetching = (isFetching) => {
    return {
        type: SET_ANALYTIC_IS_FETCHING,
        isFetching: isFetching
    }
}

export const setClearData = () => {
    return {
        type: SET_CLEAR_DATA,
        data: []
    }
}

export const setLocationsName = (locationsName) => {
    return {
        type: SET_LOCATIONS_NAME,
        locationsName: locationsName
    }
}

const getLocationsId = (data) => {
    let ret = data.map(k => k.value)
    return ret
}

/*Get analytic data state */

export const getDataType = (type, getData, setData, topicId, since, till, grouping, filters, subtopics, pageType, chartType = 'column', chartNumber, chartSettings) => {

    return (dispatch) => {
        getData(topicId, getDateTimeFormat(since), getDateTimeFormat(till), grouping, filters, subtopics).then(data => {
           if(data.length && chartSettings.max && data.length > chartSettings.max){
                data.length = chartSettings.max
            }
            dispatch(setData({data: [...data], topicId: subtopics && subtopics.length ? subtopics[0] : topicId, type: type, chartType: chartType, chartNumber: chartNumber, chartSettings: chartSettings, pageType}));
            if(type === 'AuthorsLocations'){
                let locations = getLocationsId(data)
                dispatch(getGeoplaceDictionary(locations))
            }
        }).catch( error => {    
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
            dispatch(setAnalyticIsFetching(false))
        })
    }
}

export const getDataTypeV2 = (type, getData, setData, topicId, subtopics, params, filters, fields, pageType, limit, minCount, chartType = 'column', chartNumber, chartSettings) => {
    return (dispatch) => {
        getData(topicId, subtopics, params, {...filters}, fields, limit, minCount).then(data => {
            if((chartSettings.max && chartSettings.max > 10) && data.length && data.length > chartSettings.max){
                data.length = chartSettings.max;
            }
            dispatch(setData({data: [...data], topicId: subtopics && subtopics.length ? subtopics[0] : topicId, type: type, chartType: chartType, chartNumber: chartNumber, chartSettings: chartSettings, pageType}));
            if(type === 'AuthorsLocations'){
                let locations = getLocationsId(data)
                dispatch(getGeoplaceDictionary(locations))
            }
        }).catch( error => {  
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
            dispatch(setAnalyticIsFetching(false))
        })
    }
}

export const getGeoplaceDictionary = (locationsIds) => {
    if(locationsIds.length && locationsIds[locationsIds.length - 1] == 'null'){
        locationsIds.length = (locationsIds.length - 1);
    }
    return (dispatch) => {
        GeoplaceService.getGeoplaceDictionary(locationsIds).then( data=> {
            dispatch(setLocationsName(data))
        })
    }
}

export const getDataByType = (type, topicId, since, till, grouping, filters, subtopics, tags, maxSize) => {
    let firstFields = {}
    let secondFields = {}
    let thirdFields = {}
    let limit = 100;
    let secondLimit = 100;
    let minCount = 1;
    /*if(filters.mediaType && (filters.mediaType[0] === 'SOCIAL' || filters.mediaType[0] === 'NEWS_AGENCY')){
        delete filters.mediaType
    }*/
    return(dispatch)=>{
        dispatch(setAnalyticIsFetching(true));
        let params = {since: getDateTimeFormat(since), till: getDateTimeFormat(till), grouping}
        switch(type){
            case 'MENTIONS':
                firstFields = {firstField: '/ranged/date', secondField: 'language'};
                secondFields = {firstField: '/language'};
                dispatch(getDataTypeV2('languageRange', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'area', 'first',{label: 'languageDate', title: 'MENTIONING_BY_DATE', graphicType: {label: 'date', data: 'language'}, height: 290, width: '98%'}));
                dispatch(getDataTypeV2('language', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'donut', 'second',{label: 'PieValue', title: 'MENTIONING_BY_LANG', height: 290, width: '60%', metric: true}));
                //dispatch(getDataType('language', AnalyticService.getAnalyticLanguage, setSecondData, topicId, since, till, grouping, filters, subtopics, type, 'donut', 'second',{label: 'PieValue', title: 'MENTIONING_BY_LANG', height: 290, width: '60%', metric: true}));
                dispatch(setThirdData([]));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                break;
            case 'TONE':
                firstFields = {firstField: '/ranged/date', secondField: 'sentiment'};
                secondFields = {firstField: '/language', secondField: 'sentiment'};
                thirdFields = {firstField: '/sentiment'}
                dispatch(getDataTypeV2('SentimentRange', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'area', 'first',{label: 'sentiment', title: 'TONE_BY_DATE', graphicType: {label: 'date', data: 'sentiment'}, height: 270, width: '98%'}));
                dispatch(getDataTypeV2('Sentiment', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'column', 'second',{label: 'LanguageSentiment', title: 'TONE_BY_LANG', height: 270, width: '47%', metric: true}));
                dispatch(getDataTypeV2('SentimentData',  AnalyticServiceV2.getFieldsAnalytic, setThirdData, topicId, subtopics, params, filters, thirdFields, type, limit, minCount, 'donut', 'third',{label: 'sentiment', title: 'SENTIMENT', graphicType: {label: 'sentiment', data: 'sentiment'}, height: 270, width: '47%'}))
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                break;
            case 'TYPES_OF_POSTS':
                firstFields = {firstField: '/ranged/date', secondField: 'type'};
                secondFields = {firstField: '/language', secondField: 'type'};
                
                dispatch(getDataTypeV2('PublicationRange',AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'area', 'first',{label: 'postType', title: 'POST_TYPES_BY_DATES', graphicType: {label: 'date', data: 'type'}, height: 250, width: '98%'}));
                dispatch(getDataTypeV2('Publication', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'column', 'second',{label: 'typeOfPosts', title: 'POST_TYPES_BY_LANG', height: 290, width: '98%', metric: true}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'SOCIAL_NETWORKS':
                firstFields = {firstField: 'domain', secondField: 'sentiment'};
                secondFields = {firstField: 'domain'};
                //filters.mediaType = ['SOCIAL']
                //filters.domain = ['facebook.com', 'vk.com', 'youtube.com', 'telegram.org', 'instagram.com', 'twitter.com', 'tiktok.com', 'ok.ru', 'my.mail.ru', 'threads.net'];
                dispatch(getDataTypeV2('Social', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'column', 'first',{label: 'top', title: 'SOCIAL_NETWORKS_BY_SENTIMENT', graphicType: {label: 'date', data: 'type'}, height: 250, width: '98%'}));
                dispatch(getDataTypeV2('SocialSentiment', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'donut', 'second',{label: 'typeOfPosts', title: 'SOCIAL_NETWORKS', height: 290, width: '98%', metric: true}));
                dispatch(setThirdData([]))
                break;
            case 'AUTHORS':
                firstFields = {firstField: '/author', secondField: 'sentiment'};
                secondFields = {firstField: '/language', secondField: 'type'};
                dispatch(getDataTypeV2('AuthorsSentiment', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, maxSize.first, minCount, 'column', 'first',{label: 'followers_count', title: 'AUTHORS', graphicType: {label: 'author', data: 'sentiment'}, height: 450, width: '100%', max: maxSize.first}));
                dispatch(getDataType('FollowersCount', AnalyticService.getFollowersCounts, setSecondData, topicId, since, till, grouping, filters, subtopics, type, 'column', 'second', {label: 'field', title: 'INFLUENCE_OF_AUTHORS', height: 450, width: '100%', max: null, metric: true}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'TOP_20_MASS_MEDIA':
                firstFields = {firstField: 'domain', secondField: 'sentiment'};
                secondFields = {firstField: 'domain', secondField: 'language'};
                limit = 20;

                //filters.mediaType = ['NEWS_AGENCY', 'TV', 'PRINT', 'INTERNET'];
                dispatch(getDataTypeV2('Top20', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'column', 'first', {label: 'top', title: 'TOP_20_MASS_MEDIA', graphicType: {label: 'domain', data: 'sentiment'}, height: 450, width: '100%'}));
                dispatch(getDataTypeV2('Top20Languages', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'column', 'second',{label: 'followers_count', title: 'TOP_20_MASS_MEDIA_BY_LANG', height: 450, width: '100%', metric: true}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'SOURCE_TYPE':
                firstFields = {firstField: 'media_type', secondField: 'sentiment'};
                dispatch(getDataTypeV2('MediaType', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'column', 'first', {label: 'followers_count', title: 'TONE_BY_MASS_MEDIA_TYPES', graphicType: {label: 'mediaType', data: 'sentiment'}, height: 450, width: '100%', metric: true}));
                dispatch(setSecondData(null))
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'TAGS':
                //AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'column', 'second',
                firstFields = {firstField: 'tags', secondField: 'sentiment'};
                secondFields = {firstField: 'ranged/date', secondField: 'tags'};
                dispatch(getDataTypeV2('TagsList', AnalyticServiceV2.getFieldsAnalytic, setThirdData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'area', 'third', {label: 'tags', title: 'POSTS_BY_TAGS', tags: tags, height: 290, width: '100%'}));
                dispatch(getDataTypeV2('Tags', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, limit, minCount, 'column', 'first', {label: 'valueSentiment', title: 'POSTS_BY_TAGS', tags: tags, height: 290, width: '100%'}),);
                dispatch(getDataTypeV2('TagsRange', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'area', 'second', {label: 'value', title: 'TAGS_BY_TIME', tags: tags, height: 290, width: '100%'}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                break;
            case 'REACH_OF_SOURCE':
                dispatch(getDataType('AuthorsInvolvementSentiment', AnalyticService.getInvolementSentiment, setFirstData, topicId, since, till, grouping, filters, subtopics, type, 'column', 'first', {label: 'involement', title: 'REACH_OF_SOURCE_BY_SENTIMENT', height: 290, width: '100%'}));
                dispatch(getDataType('AuthorsInvolvementMediaTypes', AnalyticService.getInvolementSentiment, setSecondData, topicId, since, till, grouping, filters, subtopics, type, 'donut', 'second', {label: 'involement', title: 'REACH_OF_SOURCE_BY_COUNT', height: 290, width: '100%', metric: true}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'KEY_WORDS':
                firstFields = {firstField: 'keywords', secondField: 'sentiment'};
                secondFields = {firstField: 'ranged/date', secondField: 'keywords'};
                thirdFields = {firstField: 'keywords', secondField: 'sentiment'}
                //limit = 20;
                //secondLimit = 20;
                dispatch(getDataTypeV2('KeyWords', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, maxSize.first, minCount, 'column', 'first', {label: 'valueSentiment', title: 'POSTS_BY_KEYWORDS', height: 450, width: '100%', max: maxSize.first}));
                dispatch(getDataTypeV2('KeyWordsRange', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, maxSize.second, minCount, 'line', 'second', {label: 'value', title: 'KEYWORDS_BY_TIME', height: 290, width: '100%',  max: maxSize.second}));
                dispatch(getDataTypeV2('KeyWordsList',  AnalyticServiceV2.getFieldsAnalytic, setThirdData, topicId, subtopics, params, filters, thirdFields, type, 120, minCount, 'column', 'first', {label: 'keywords', title: 'POSTS_BY_KEYWORDS', height: 290, width: '100%'}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                break;
            case 'GEOGRAPHY_OF_AUTHORS':
                firstFields = {firstField: 'profile_location_id'};
                dispatch(getDataTypeV2('AuthorsLocations', AnalyticServiceV2.getFieldsAnalytic, setFirstData, topicId, subtopics, params, filters, firstFields, type, maxSize.first, minCount, 'donut', 'first', {label: 'authorGeography', title: 'GEOGRAPHY_OF_AUTHORS', height: 450, width: '100%', max: maxSize.first}));
                //dispatch(getDataType('AuthorsLocations', AnalyticService.getAuthorsLocationsIds, setFirstData, topicId, since, till, grouping, filters, subtopics, type, 'donut', 'first', {label: 'authorGeography', title: 'GEOGRAPHY_OF_AUTHORS', height: 450, width: '100%', max: maxSize.first}));
                
                dispatch(setSecondData(null))
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'AUTHOR_STATISTICS':
                secondFields = {firstField: 'profile_gender'};
                dispatch(getDataType('AuthorsAge', AnalyticService.getAuthorsAge, setFirstData, topicId, since, till, grouping, filters, subtopics, type, 'column', 'first', {label: 'ages', title: 'AUTHOR_STATISTICS_AGE', height: 290, width: '100%'}));
                dispatch(getDataTypeV2('AuthorsGender', AnalyticServiceV2.getFieldsAnalytic, setSecondData, topicId, subtopics, params, filters, secondFields, type, limit, minCount, 'donut', 'second', {label: 'genders', title: 'AUTHOR_STATISTICS_GENDER', height: 390, width: '100%'}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, since, till, grouping, filters, subtopics, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                dispatch(setThirdData([]))
                break;
            case 'POPULAR_WORDS':
                dispatch(getDataType('PopularWordsBurst', PopularWordsService.getPopularWordsBurst, setFirstData, topicId, since, till, grouping, filters, subtopics, type, 'area', 'first', {label: 'PopularValue', title: 'POPULAR_WORDS_BY_TIME', graphicType: {label: 'date', data: 'language'}, height: 290, width: '100%'}));
                dispatch(getDataType('PopularWordsFacets', PopularWordsService.getPopularWordsFacets, setSecondData, topicId, since, till, grouping, filters, subtopics, type, 'column', 'second', {label: 'PopularValueSentiment', title: 'POPULAR_WORDS_BY_SENTIMENT', height: 450, width: '100%'}));
                dispatch(getDataType('PopularWords', PopularWordsService.getPopularWords,setThirdData, topicId, since, till, grouping, filters, subtopics, type, 'column', 'third', {label: 'popular', title: 'POPULAR_WORDS', height: 290, width: '100%'}));
                //dispatch(getDataType('metric', AnalyticService.getSentimentRange, setMetricData, topicId, subtopics, since, till, grouping, filters, type, 'metric', 'metric',{label: 'metric', title: 'METRICS', position: 'second', height: 290, width: '98%'}));
                break;
            }
    }
}